module.exports = __webpack_public_path__ + "9b8e432257fdc488996d642f4e58f3b7.pdf";